// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as VideoTextPromoBlock__Settings$PrezzeeRibbon from "./VideoTextPromoBlock__Settings.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(VideoTextPromoBlock__Settings$PrezzeeRibbon.videoBottomOffsetMobile)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(489)),
      BsCssJs$PrezzeeRibbon.flexShrink(0),
      BsCssJs$PrezzeeRibbon.flexGrow(0),
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.px(242)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(11)),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-11)),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(-24))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(33)),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(-58))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.px(180)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(364)),
            BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(5))
          ])
    ]);

var Styles = {
  Settings: undefined,
  container: container
};

function VideoTextPromoBlock__VideoContainer(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    container,
                    className$1
                  ])
            });
}

var make = VideoTextPromoBlock__VideoContainer;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
